<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-button
        type="primary"
        size="small"
        @click="getData"
        :loading="isLoading"
      >
        <i class="el-icon-refresh"></i> {{ $t("refresh") }}
      </el-button>
    </div>

    <div style="padding: 30px;" v-loading="isLoading">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card shadow="hover">
            <div slot="header">
              <i class="el-icon-user"></i> {{ $t("customerBalance") }}
            </div>
            <div class="stat-value text-primary">
              FCFA {{ fmt(data.customerAccountAmount) }}
            </div>
            <div class="stat-sub">{{ $t("accountAmount") }}</div>
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="hover">
            <div slot="header">
              <i class="el-icon-office-building"></i> {{ $t("orgBalance") }}
            </div>
            <div class="stat-value text-success">
              FCFA {{ fmt(data.orgTotal) }}
            </div>
            <div class="stat-sub">
              {{ $t("accountAmount") }}: FCFA {{ fmt(data.orgAccountAmount) }}
              &nbsp;|&nbsp;
              {{ $t("cashAmount") }}: FCFA {{ fmt(data.orgCashAmount) }}
            </div>
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card shadow="hover" style="border: 2px solid #409eff;">
            <div slot="header"><b>TOTAL</b></div>
            <div class="stat-value text-danger">FCFA {{ fmt(data.total) }}</div>
            <div class="stat-sub">{{ $t("electronicMoneyOutstanding") }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import card from "@/api/card";

export default {
  name: "electronicMoneyOutstanding",
  data() {
    return {
      isLoading: false,
      data: {
        customerAccountAmount: 0,
        orgAccountAmount: 0,
        orgCashAmount: 0,
        orgTotal: 0,
        total: 0,
      },
    };
  },
  methods: {
    fmt(val) {
      if (!val) return "0";
      return Number(val).toLocaleString("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    getData() {
      this.isLoading = true;
      card.getElectronicMoneyOutstanding({
        success: (res) => {
          if (res.code === 200) this.data = res.data;
          this.isLoading = false;
        },
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.stat-value {
  font-size: 26px;
  font-weight: 700;
  margin: 10px 0;
}
.stat-sub {
  font-size: 12px;
  color: #909399;
}
</style>
